/* eslint-disable max-len */
import { HttpClient, HttpParams } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DataRest, IdDataRest, KeycodeCheckData, SiteData, SiteExtTechAclData, SitesData, TransferSitesData } from '../model/api/data-rest';
import { LocalSite, Site } from '../model/site';
import { resources } from './api';

@Injectable({
    providedIn: 'root'
})
export class SiteService { // service that interacts with site-ms for devices and device-tree CRUD
    constructor(
        private http: HttpClient
    ) {

    }

    getSite(id: number): Observable<SiteData> { // get single site by Id
        return this.http.get<SiteData>(`${environment.apiUrl}${resources.get('sites')}/${id}`);
    }

    getSites(userId?: number): Observable<SitesData> { // fetch all sites
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        return this.http.get<SitesData>(`${environment.apiUrl}${resources.get('sites')}`, { params });
    }

    getSitesOnlineDevices(userId?: number): Observable<SitesData> { // fetch all sites
        let params = new HttpParams();
        if (userId) {
            params = params.set('userId', userId.toString());
        }
        return this.http.get<SitesData>(`${environment.apiUrl}${resources.get('sites-online-device')}`, { params });
    }

    insertSite(site: Site): Observable<SiteData> { // create new site
        return this.http.post<SiteData>(`${environment.apiUrl}${resources.get('sites')}`, site);
    }

    updateSite(site: Site): Observable<DataRest> { // update site info
        return this.http.put<DataRest>(`${environment.apiUrl}${resources.get('sites')}/${site.Id}`, site);
    }

    deleteSite(id: number): Observable<DataRest> { // delete site
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('sites')}/${id}`);
    }

    deleteSharedSite(id: number): Observable<DataRest> { // delete site
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('sites')}/${id}${resources.get('delete')}${resources.get('share')}`);
    }

    assignTechnicianToSite(siteId: number, technicianId: number): Observable<DataRest> {
        return this.http.patch<DataRest>(
            `${environment.apiUrl}${resources.get('sites')}/${siteId}${resources.get('assignTechnician')}/${technicianId}`,
            {}
        );
    }

    unassignTechnicianToSite(siteId: number): Observable<DataRest> {
        return this.http.patch<DataRest>(`${environment.apiUrl}${resources.get('sites')}/${siteId}${resources.get('unassignTechnician')}`, {});
    }

    getSiteTransfers(): Observable<TransferSitesData> {
        return this.http.get<TransferSitesData>(`${environment.apiUrl}${resources.get('transferSites')}`);
    }

    deleteSiteTransfer(siteId: number): Observable<IdDataRest> {
        return this.http.delete<IdDataRest>(`${environment.apiUrl}${resources.get('transferSites')}/${siteId}`);
    }

    transferSite(email: string, firstName: string, lastName: string, siteId: number): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('sites')}${resources.get('transfer')}`, {
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            SiteId: siteId
        });
    }

    transferSiteNew(email: string, firstName: string, lastName: string, siteId: number): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('invitations')}`, {
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            SiteId: siteId
        });
    }

    checkKeycode(keycode: string) {
        return this.http.get<KeycodeCheckData>(`${environment.apiUrl}${resources.get('devicesAcl')}${resources.get('registry')}/${keycode}`);
    }

    confirmSiteTransfer(siteId: number, ownerId: number, verification: string, userId?: number): Observable<DataRest> {
        let params = new HttpParams()
            .set('siteId', siteId.toString())
            .set('ownerId', ownerId.toString())
            .set('verification', verification);
        if (userId) {
            params = params.set('userId', userId.toString());
            return this.http.post<DataRest>(
                `${environment.apiUrl}${resources.get('sites')}${resources.get('confirm')}${resources.get('transfer')}${resources.get('onSignup')}`,
                {},
                { params }
            );
        } else {
            return this.http.post<DataRest>(
                `${environment.apiUrl}${resources.get('sites')}${resources.get('confirm')}${resources.get('transfer')}`,
                {},
                { params }
            );
        }
    }

    // getThermoDevice(keycode: string): Observable<Thermo> { // fetch all thermo
    //     return this.http.get<Thermo>(`${environment.apiUrlThermo}${resources.get('devices')}/${keycode}`);
    // }

    //updateThermo(thermo: Thermo): Observable<DataRest> { // update thermo
    //    return this.http.post<DataRest>(`${environment.apiUrlThermo}${resources.get('control')}/${thermo.keycode}`, thermo);
    //}

    updateAutomationRtc(siteId: number): Observable<DataRest> { // update thermo
        const params = new HttpParams()
            .set('SiteId', siteId.toString());
        return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('automations')}${resources.get('setrtc')}`, params);
    }

    getSitesExtendedWithTechnicianIdReqOpen(): Observable<SiteExtTechAclData> {
        return this.http.get<SiteExtTechAclData>(`${environment.apiUrl}${resources.get('sitesExtTechAcl')}`);
    }

    getLocalSites(): Observable<LocalSite[]> {
        return this.http.get<LocalSite[]>(`${environment.apiUrl}${resources.get('v1')}${resources.get('local')}${resources.get('sites')}`);
    }

}
